import { render, staticRenderFns } from "./puzzling_sessions.vue?vue&type=template&id=09a3945c&scoped=true&"
import script from "./puzzling_sessions.vue?vue&type=script&lang=js&"
export * from "./puzzling_sessions.vue?vue&type=script&lang=js&"
import style0 from "./puzzling_sessions.vue?vue&type=style&index=0&id=09a3945c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a3945c",
  null
  
)

export default component.exports